import React from 'react';
import { CheckSquare, Shield, FileCheck, ClipboardCheck } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Compliance feature
 * Displays information about the Compliance feature and its benefits
 */
export const ComplianceFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Compliance Management"
      description="Track, manage, and demonstrate compliance with security standards and regulatory requirements with comprehensive assessment tools."
      icon={<CheckSquare className="h-8 w-8 text-blue-600" />}
      featureName="compliance"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <ClipboardCheck className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">NACSA Checklist</h3>
          </div>
          <p className="text-gray-400">
            Comprehensive compliance checklist aligned with National Cyber Security Authority (NACSA) requirements and best practices.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <FileCheck className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Compliance Tracking</h3>
          </div>
          <p className="text-gray-400">
            Track compliance status across multiple frameworks and standards with detailed progress monitoring and reporting.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Shield className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Gap Analysis</h3>
          </div>
          <p className="text-gray-400">
            Identify compliance gaps and security weaknesses with automated assessment tools and actionable recommendations.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <CheckSquare className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Evidence Collection</h3>
          </div>
          <p className="text-gray-400">
            Streamline compliance evidence collection and documentation for audits and regulatory requirements.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
